import InvoiceViewController from './InvoiceViewController';

export default InvoiceViewController;
